export default __webpack_public_path__ + "static/826-bca40dfd7fcec5c3f5464716c4656a9c.gif";